export default __webpack_public_path__ + "static/media/modal-edge-shape-1.665dca70.png";